import { Box, HStack, IconButton, Text } from "@chakra-ui/react";
import { SmallCloseIcon } from "@chakra-ui/icons";
import { Header, MetricProto } from "build-ts/metadata";
import { KGColumnProto } from "build-ts/knowledege_graph";
import React from "react";
import { EntityKind, EntityNameTooltip } from "./DataScopeLeftPanel";

const EntityRightPanelCard: React.FC<{
  title: string;
  header: Header;
  entityKind: EntityKind;
  isSessionNew?: boolean;
  onRemove: () => void;
  isRemoveDisabled?: boolean;
  footer?: React.ReactNode;
  subtitle?: React.ReactNode;
  errorIndicator?: React.ReactNode;
  kgColumnProtoMap: Map<string, KGColumnProto>;
  dataModelList: Header[];
  metricProtoMap: Map<string, MetricProto>;
}> = ({
  title,
  header,
  entityKind,
  isSessionNew = false,
  onRemove,
  isRemoveDisabled = false,
  footer,
  subtitle,
  errorIndicator,
  kgColumnProtoMap,
  dataModelList,
  metricProtoMap,
}) => {
    const prPad = errorIndicator ? "4.75rem" : "2.25rem";

    const titleContent = (
      <Box w="100%" pr={prPad} minH="30px" minW={0} flexShrink={0} overflow="hidden">
        <Text
          as="span"
          display="block"
          fontSize="sm"
          fontWeight="700"
          color="gray.800"
          lineHeight="short"
          textAlign="left"
          noOfLines={3}
          wordBreak="break-word"
          mb={0}
        >
          {title}
        </Text>
      </Box>
    );

    return (
      <Box
        position="relative"
        h="100%"
        minH="100%"
        minW={0}
        borderWidth={isSessionNew ? "1.5px" : "1px"}
        borderLeftWidth={isSessionNew ? "4px" : "1px"}
        borderColor={isSessionNew ? "green.400" : "gray.400"}
        borderRadius="md"
        bg="white"
        p={2.5}
        display="flex"
        flexDir="column"
      >
        <HStack
          position="absolute"
          top={1.5}
          right={1}
          spacing={0.5}
          zIndex={2}
          align="center"
          pointerEvents="auto"
          cursor="default"
        >
          {errorIndicator}
          <IconButton
            size="xs"
            variant="ghost"
            colorScheme="gray"
            minW="28px"
            h="28px"
            icon={<SmallCloseIcon />}
            aria-label="Remove from access"
            isDisabled={isRemoveDisabled}
            onClick={e => { e.stopPropagation(); onRemove(); }}
          />
        </HStack>

        <Box
          position="relative"
          flex="1"
          minH={0}
          w="100%"
          display="grid"
          gridTemplateRows={footer ? "1fr auto" : "1fr"}
        >
          <Box position="relative" minH={0} w="100%" h="100%" display="flex" flexDir="column" alignItems="stretch">
            <EntityNameTooltip
              header={header}
              kind={entityKind}
              dataModelList={dataModelList}
              metricProtoMap={metricProtoMap}
              kgColumnProtoMap={kgColumnProtoMap}
              shouldWrapChildren={false}
            >
              {titleContent}
            </EntityNameTooltip>
            {subtitle && (
              <Box w="100%" maxW="100%" pt={1} minW={0} flex="1" minH={0}>
                {subtitle}
              </Box>
            )}
          </Box>
          {footer && (
            <Box cursor="default" minW={0} onClick={e => e.stopPropagation()}>
              {footer}
            </Box>
          )}
        </Box>
      </Box>
    );
  };

export default EntityRightPanelCard;
